import * as React from "react";
import FutureCardContent from "./future";
import { IEvent } from "@/types/event";
import { Box, Stack, Dialog } from "@mui/material";
import { TitleWithValue } from "@/components/shared";
import { useTranslation } from "react-i18next";
import { ASSETS_URL } from "@/constants";
import { useThemeConfig } from "@/context/theme";

interface IChildrenDefaultEvent {
  item?: IEvent;
}

const ChildrenDefaultEvent: React.FC<IChildrenDefaultEvent> = ({ item }) => {
  // Getting translation object
  const { t } = useTranslation(["common"]);

  // Getting Theme
  const { themeConfig } = useThemeConfig()

  // State to control the image modal
  const [open, setOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState<string | null>(null);

  // Function to handle image click
  const handleImageClick = (src: string) => {
    setSelectedImage(src);
    setOpen(true);
  };

  // Function to close the modal
  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  if (item.expires_at) return <FutureCardContent item={item} />;

  return (
    <Stack direction="column" pb={1} spacing={2}>
      <TitleWithValue
        title={
          <>
            {item.type === "Finance" && item.done !== 1 && (
              <span style={{ marginRight: "6px" }}>
                {t("common:prediction")}{" "}
              </span>
            )}
            {item.title}
          </>
        }
        value={""}
        hasDoubleDot={false}
        justifyContent="space-between"
        colorTitle={"text.primamry"}
        variantTitle="bodyBold"
        variantValue={"bodyMedium"}
        alignItems="flex-start"
      />
      {/* revenue_percent part */}
      {item.revenue_percent && (
        <TitleWithValue
          title={t("common:depsoited_profit")}
          value={`${item.revenue_percent} %`}
          hasDoubleDot={false}
          justifyContent="space-between"
          colorTitle={"text.secondary"}
          variantTitle="bodyBold"
          variantValue={"bodyMedium"}
          alignItems="flex-start"
        />
      )}
      <TitleWithValue
        title={
          <span
            style={{
              whiteSpace: "pre-line",
            }}
          >
            {item.description}
          </span>
        }
        value={""}
        hasDoubleDot={false}
        justifyContent="space-between"
        colorTitle={"text.secondary"}
        variantTitle="bodyBold"
        variantValue={"bodyMedium"}
        alignItems="flex-start"
      />

      {(item?.estimated_profit) && (
        <TitleWithValue
          title={item?.done ? t('common:estimated_profit_deposited') : t('common:estimated_deposited')}
          value={((item?.estimated_profit)).toFixed(0)?.withCommas()?.withPriceUnit()}
          hasDoubleDot={false}
          justifyContent="space-between"
          colorTitle={"text.secondary"}
          variantTitle="bodyBold"
          variantValue={"bodyMedium"}
          alignItems="flex-start"
        />
      )}


      {/* Render images if item.media has data */}
      {/* {item.media && item.media.length > 0 && (
        <Stack direction="row" spacing={1} mt={2} flexWrap="wrap">
          {item.media.map((mediaItem, index) => (
            <Box
              key={index}
              component="img"
              src={mediaItem.original_url}
              alt={`media-${index}`}
              sx={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
                cursor: "pointer", // Make it look clickable
              }}
              onClick={() => handleImageClick(mediaItem.original_url)} // Handle click
            />
          ))}
        </Stack>
      )} */}

      {/* Render files if item.media has data */}
      {item.media && item.media.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} flexWrap="wrap">
          {item.media.map((mediaItem, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                // width: "100px",
                // height: "100px",
                borderRadius: "8px",
                // bgcolor: "rgba(0,0,0,0.05)",
                cursor: "pointer",
                // p: 1,
              }}
              onClick={() => {
                // open in new tab instead of preview modal
                window.open(mediaItem.original_url, "_blank");
              }}
            >
              {/* Icon */}
              <Box
                component="img"
                src={themeConfig?.config?.media?.document_download}
                alt="Download"
                sx={{
                  width: 40,
                  height: 40,
                  mb: 1,
                }}
              />
            </Box>
          ))}
        </Stack>
      )}


      {/* Dialog to show the enlarged image */}
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        {selectedImage && (
          <Box
            component="img"
            src={selectedImage}
            alt="Selected"
            sx={{ width: "100%", height: "auto", objectFit: "contain" }} // Make it responsive
          />
        )}
      </Dialog>
    </Stack>
  );
};

export default ChildrenDefaultEvent;
